import React        from 'react';
import {
    Route,
    Routes }        from 'react-router-dom';


// @ts-expect-error
import './styles/index.scss';

import intelitransit    from './utils/InteliTransit';
import Role             from './utils/Role';
import Hamburger        from './components/Hamburger';

import Applicant        from './Applicant';
import Clerk            from './Clerk';
import Manager          from './Manager';

interface Props {
}

interface State {
    menuIsOpen  : boolean;
}

export default class App extends React.Component<Props,State> {

    private static minWidthQuery = "(min-width: 768px)";
    private static rolesOrder = {
        "Clerk"         : 1,
        "Manager"       : 2,
        "Applicant"     : 3,
    } as Record<string,number>;
    constructor( props:Props ) {
        super(props);
        this.state = {
            menuIsOpen : window.matchMedia(App.minWidthQuery).matches
        };
        intelitransit.menu = {isOpen : this.state.menuIsOpen};
    }
    static getDerivedStateFromError() {
        return {};
    }
    componentDidCatch( error:Error, info:Record<string,any> ) {
        console.error(`Application caught error:`,error,`info:`,info);
    }
    menuItemClick() {
        if( !window.matchMedia(App.minWidthQuery).matches ) {
            intelitransit.menu = {isOpen:false};
            this.setState({menuIsOpen:false});
        }
    }
    render() {
        // Always make sure that passenger goes first
        // In case of fixed routes only, there is no passenger experience
        const userRoles = [...(intelitransit.user?.roles||[]),'Applicant'];
        const roles     = userRoles.sort((r1,r2)=>(App.rolesOrder[r1]-App.rolesOrder[r2])).map( role => {
            if( role==='Clerk' )
                return Clerk(this);
            if( role==='Manager' )
                return Manager(this);
            return Applicant(this);
        }) || [Applicant(this)];
        const menuItems     = roles.map(role=>role.items).flat();
        const firstRoute    = roles[0]?.routes[0];
        const menuLinksCount= menuItems.reduce( (acc,mi) => {
            if( mi.props.children?.props?.className==='menu__link' )
                acc++;
            return acc;
        },0);
        return (<div id="outer-container">
            <Hamburger
                menuProps = {{
                    outerContainerId : "outer-container",
                    pageWrapId       : "pagewrap-container",
                    // Does not make sense to open menu if there is only one menu item
                    isOpen           : this.state.menuIsOpen && (menuLinksCount>1),
                    onStateChange    : ((menuState:{isOpen:boolean}) => {
                        intelitransit.menu = {isOpen : menuState.isOpen};
                        return this.setState({menuIsOpen:menuState.isOpen});
                    })
                }}
            >
                { intelitransit.user && (
                    <div className="profile">
                        <img className="profile__image" id="profile__image" alt="icon" height={31} width={31} src={intelitransit.user.picture||''}/>
                        <span className="profile__username">{intelitransit.user!.fname||'no name'}</span>
                    </div>
                )}
                { menuItems.map((mi,ndx)=>(<React.Fragment key={ndx}>{mi}</React.Fragment>)) }
                <div className="menu__footerLink">
                    <a className="menu__link" href="/privacy_policy"><span className="menu__name">Privacy</span></a>
                    <a className="menu__link" href="/terms_of_service"><span className="menu__name">Terms Of Service</span></a>
                </div>
            </Hamburger>
            <div id="pagewrap-container">
                <Routes>
                    {
                        roles.map(role=>role.routes)
                    }
                    { firstRoute ? <Route key={'default'} path="*" element={firstRoute?.props?.element}/> : null }
                </Routes>
            </div>
        </div>);
    }
}
